import { object, string, date, number } from 'yup';

// types
import { EventType } from 'pages/MerchantPages/Assets/InitialCreate/ContentType';

export const validationSchema = object().shape({
  contentCategory: string().required('*Requiered'),
  industry: string().when(['contentCategory'], {
    is: (contentCategory: string) => contentCategory === EventType.LIVE,
    then: string().required('*Required'),
  }),
  eventName: string().when(['contentCategory'], {
    is: (contentCategory: string) => contentCategory === EventType.LIVE,
    then: string().max(80, 'Limited to maximum 80 characters').required('*Required'),
  }),
  webPage: string().when(['contentCategory'], {
    is: (contentCategory: string) => contentCategory === EventType.LIVE,
    then: string().required('*Required'),
  }),
  eventDate: date()
    .when(['contentCategory'], {
      is: (contentCategory: string) => contentCategory === EventType.LIVE,
      then: date().required('*Required'),
    })
    .nullable(),
  expectedViewership: number().when(['contentCategory'], {
    is: (contentCategory: string) => contentCategory === EventType.LIVE,
    then: number()
      .required('*Required')
      .positive('The quantity must be positive number.')
      .typeError('The quantity must be a number.'),
  }),
  replayAvailable: string().when(['contentCategory'], {
    is: (contentCategory: string) => contentCategory === EventType.LIVE,
    then: string().required('*Required'),
  }),
  eventDescription: string().when(['contentCategory', 'isAdvertised'], {
    is: (contentCategory: string, isAdvertised: boolean) => contentCategory === EventType.LIVE && isAdvertised,
    then: string().required('*Required'),
  }),
});
